import AlertTriangle from '@crehana/compass.icons.outline/AlertTriangle';
import Refresh from '@crehana/compass.icons.outline/Refresh';
import { Button } from '@crehana/compass.ui/button';
import { useCommunityInternalCommsTranslations } from '../../hooks/use-translations';

type TScheduledErrorViewProps = {
  onRetry: () => void;
};

export const ScheduledErrorView: React.FC<TScheduledErrorViewProps> = ({
  onRetry,
}) => {
  const { t } = useCommunityInternalCommsTranslations();

  return (
    <div className="tw-cds-bg-primary tw-cds-rounded-s tw-border tw-border-solid tw-cds-border-color-default tw-overflow-hidden">
      <div className="tw-px-3.2 tw-py-2 tw-border-b tw-border-solid tw-cds-border-color-default tw-flex tw-items-center tw-gap-x-0.8">
        <h3 className="tw-cds-font-subtitle-03 tw-cds-text-primary">
          {t('TABS_SCHEDULED_LABEL')}
        </h3>
        <span className="tw-cds-font-body-02 tw-cds-text-secondary tw-cds-bg-secondary tw-cds-rounded-round tw-px-0.8 tw-py-0.2 tw-min-w-[2rem] tw-text-center">
          0
        </span>
      </div>
      <div className="tw-p-4 tw-flex tw-items-center tw-justify-center tw-min-h-[32rem]">
        <div className="tw-space-y-2.4 tw-text-center">
          <div className="tw-cds-rounded-round tw-h-5.6 tw-w-5.6 tw-flex tw-items-center tw-justify-center tw-cds-bg-feedback-alert tw-mx-auto">
            <div className="tw-cds-rounded-round tw-h-4.4 tw-w-4.4 tw-flex tw-items-center tw-justify-center tw-cds-bg-feedback-alert">
              <AlertTriangle size={28} className="tw-cds-text-feedback-alert" />
            </div>
          </div>
          <div className="tw-space-y-0.8">
            <h4 className="tw-cds-font-subtitle-03 tw-cds-text-primary">
              {t('ERROR_TITLE')}
            </h4>
            <p className="tw-cds-font-body-02 tw-cds-text-secondary">
              {t('ERROR_DESCRIPTION')}
            </p>
          </div>
          <Button type="button" onClick={onRetry}>
            <Refresh size={16} className="tw-text-inherit" />
            {t('ERROR_RETRY_BUTTON')}
          </Button>
        </div>
      </div>
    </div>
  );
};
